import ApiService from "../../utils/ApiService";

export const prepareRestaurantSwitchUserData = (currentUser, parentRestaurantId) => {
  const superAdminRestaurants = currentUser.isRestaurantSwitchEnabled ? currentUser.superAdminRestaurants : currentUser.restaurants

  // The below normalAdminRestaurants array will have only one parent restaurant
  let normalAdminRestaurants = superAdminRestaurants.filter(item => item.parentRestaurantId === parentRestaurantId)
  let defaultBranch = null;

  normalAdminRestaurants = normalAdminRestaurants.map(parentRes => {
    parentRes.branches = parentRes.branches.map(resItem => Object.assign({}, resItem, {role: 'Admin'}))
    defaultBranch = parentRes.branches[0];
    defaultBranch.isDefault = true;
    parentRes.branches[0] = defaultBranch;

    return parentRes;
  })

  console.log('-----normalAdminRestaurants----', normalAdminRestaurants);
  console.log('-----defaultBranch----', defaultBranch);

  if (!defaultBranch) {
    return null;
  }
  
  const userData = {
    isPayLater: defaultBranch.acceptPayAfterEat,
    countryCode: currentUser.countryCode,
    defaultBranchId: defaultBranch.restaurantId,
    defaultBranchRole: defaultBranch.role,
    id: currentUser.id,
    isSuperAdmin: false,
    kitchenSlipOnly: defaultBranch.kitchenSlipOnly,
    name: currentUser.name, 
    inventoryType: defaultBranch.inventoryType,
    isVatIncluded: defaultBranch.isVatIncluded,
    phone: currentUser.phone,
    restaurants: normalAdminRestaurants,
    isRestaurantSwitchEnabled: true,
    superAdminRestaurants,
    token: currentUser.token
  };

  return userData;
};

export const prepareUserDataOnLeaveRestaurant = (currentUser) => {  
  const userData = {
    isPayLater: false,
    countryCode: currentUser.countryCode,
    defaultBranchId: '',
    defaultBranchRole: '',
    id: currentUser.id,
    isSuperAdmin: true,
    kitchenSlipOnly: false,
    name: currentUser.name, 
    inventoryType: '',
    isVatIncluded: false,
    phone: currentUser.phone,
    restaurants: currentUser.superAdminRestaurants,
    isRestaurantSwitchEnabled: false,
    superAdminRestaurants: [],
    token: currentUser.token
  };

  return userData;
}


export const getBranchesRestaurantSwitch = (parentRestaurantId, parentRestaurants) => {
  const parentRestaurant = parentRestaurants.find(item => item.parentRestaurantId === parentRestaurantId);

  if (parentRestaurant === undefined) {
    return [];
  }

  return parentRestaurant.branches;
}